// ============================================
// Token 存取工具
// ============================================
// 只存储 Token，不存储用户信息
// 用户信息在路由守卫中按需获取

const TOKEN_KEY = 'rbac_token'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function clearAuth() {
  removeToken()
}
